import pageHeader from "../components/pageHeader/locals/en.json";
import aboutSection from "../components/aboutSection/locals/en.json";

export default {
  pageHeader,
  aboutSection,
};
